import { AxiosError, AxiosResponse } from 'axios';
import * as _ from 'lodash';
import { LoginError } from '../types/loginError';

const isAxiosError = (error: unknown): error is AxiosError => (error as AxiosError).response !== undefined;
const isLoginError = (error: unknown): error is LoginError => Object.values(LoginError).includes(error as LoginError);

export function parseAuthenticationError(error: AxiosError | LoginError| undefined | unknown): string {
  const errorMessage = parseLoginError(error);
  if (errorMessage === LoginError.NO_PHONE_NUMBER) {
    return 'נא להזין מספר טלפון';
  }
  if (errorMessage === LoginError.INVALID_PHONE_NUMBER) {
    return 'מספר הטלפון שהזנת לא תקין';
  }
  if (errorMessage === LoginError.CODE_EXPIRED) {
    return 'הקוד פג תוקף';
  }
  if (errorMessage === LoginError.CUSTOMER_DOESNT_EXISTS) {
    return 'מספר הטלפון לא רשום במערכת';
  }
  if (errorMessage === LoginError.INVALID_CODE) {
    return 'הקוד שהזנת לא תקין';
  }
  if (errorMessage === LoginError.UNKNOWN_ERROR) {
    return 'נראה שקרתה תקלה, נסו שוב בהמשך';
  }
  if (errorMessage === LoginError.MEMBER_ALREADY_EXISTS) {
    return 'נראה שנרשמת בעבר עם המספר הזה';
  }
  if (!_.isEmpty(errorMessage)) {
    return 'נראה שקרתה תקלה, נסו שוב בהמשך';
  }
  return '';
}

export function parseLoginError(error: AxiosError | LoginError| undefined | unknown): string {
  if (!error) {
    return '';
  }

  if (isLoginError(error)) {
    return error;
  }

  if (!isAxiosError(error)) {
    return LoginError.UNKNOWN_ERROR;
  }

  if (!error.response) {
    return LoginError.UNKNOWN_ERROR;
  }

  const { status, data }: Partial<AxiosResponse<string>> = error.response;
  if (status === 400) {
    return data || LoginError.UNKNOWN_ERROR;
  }
  if (status === 409) {
    return LoginError.COOKIES_DISABLED;
  }
  if (status === 403) {
    return LoginError.UN_MARKED_ERROR;
  }
  return LoginError.UNKNOWN_ERROR;
}
